// extracted by mini-css-extract-plugin
module.exports = {"title":"ShowSitePageTaskSops_title__388F6","description":"ShowSitePageTaskSops_description__15f0C","taskType":"ShowSitePageTaskSops_taskType__JdKJC"};